import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {PagesService} from "@app/_services/pages.service";
import { AuthenticationService } from '@app/_services';

@Component({
  selector: 'header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss']
})
export class HeaderComponent {

  constructor(
    private router: Router,
    public pagesService: PagesService,
    private authService: AuthenticationService
    ) {
  }
  // ngOnInit(){
  //   this.pagesService.root().subscribe(
  //     resp=> this.pagesService.rootPages = resp
  //   )
  // }

  get rootPage() {
    return this.pagesService.rootPage;
  }

  get isRootPage(){
    return !this.pagesService.currentPage?.parents.data.length && this.pagesService.currentPage
  }

  get isRusPage(){
    return this.rootPage.slug ===""
  }

  openMobileMenu(){
    this.router.navigate([{outlets: {slider: 'pages-menu'}}], {skipLocationChange: true}).then();
  }

  login() {
    this.authService.popup('login');
  }

  get isLoggedIn() {
    return this.authService.isLoggedIn;
  }

}